import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Form, Input, Button, InputNumber, DatePicker, Upload, Icon, Tag, Tabs, notification, Row, Col, Typography, Switch, Carousel } from 'antd';
import { MuiPickersUtilsProvider, KeyboardTimePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import ApiCaller from '../../../utils/api-caller';
import Toast from 'antd-mobile/lib/toast';
import Format from '../../../utils/format';
import moment from 'moment';
import CKEditor from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { Markup } from 'interweave';
import './updateretailoffer.css';

const { Search, TextArea } = Input;
const { Text, Paragraph } = Typography;
const { TabPane } = Tabs;

@inject(
    'CmsLanguageStore',
    'webSettingStore',
    'retailOfferStore'
)
@observer
class UpdateRetailOfferModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            uploading: false
        };
    }

    componentDidMount() {
        this.props.CmsLanguageStore.getActives();
        this.props.webSettingStore.getData();
    }

    // ON CLICK

    deleteBannerOnClick = () => {
        this.props.retailOfferStore.setImageUrl('');
    }

    useItemImageOnClick = () => {
        this.props.retailOfferStore.setImageUrlAsOriginalImageUrl();
    }

    createClicked = () => this.props.retailOfferStore.createRetailOffer();
    updateClicked = () => this.props.retailOfferStore.updateRetailOffer();
    cancelClicked = () => this.props.retailOfferStore.setShowUpdateRetailOfferModal(false);

    // ON CHANGE

    titleChanged = (e) => this.props.retailOfferStore.setTitle(e.target.value);
    titleChineseChanged = (e) => this.props.retailOfferStore.setTitleChinese(e.target.value);
    titleChineseTraditionalChanged = (e) => this.props.retailOfferStore.setTitleChineseTraditional(e.target.value);
    titleThaiChanged = (e) => this.props.retailOfferStore.setTitleThai(e.target.value);
    titleJapaneseChanged = (e) => this.props.retailOfferStore.setTitleJapanese(e.target.value);
    titleVietnameseChanged = (e) => this.props.retailOfferStore.setTitleVietnamese(e.target.value);

    briefDescChanged = (e) => this.props.retailOfferStore.setBriefDesc(e.target.value);
    briefDescChineseChanged = (e) => this.props.retailOfferStore.setBriefDescChinese(e.target.value);
    briefDescChineseTraditionalChanged = (e) => this.props.retailOfferStore.setBriefDescChineseTraditional(e.target.value);
    briefDescThaiChanged = (e) => this.props.retailOfferStore.setBriefDescThai(e.target.value);
    briefDescJapaneseChanged = (e) => this.props.retailOfferStore.setBriefDescJapanese(e.target.value);
    briefDescVietnameseChanged = (e) => this.props.retailOfferStore.setBriefDescVietnamese(e.target.value);

    descriptionChanged = (data) => this.props.retailOfferStore.setDescription(data);
    descriptionChineseChanged = (data) => this.props.retailOfferStore.setDescriptionChinese(data);
    descriptionChineseTraditionalChanged = (data) => this.props.retailOfferStore.setDescriptionChineseTraditional(data);
    descriptionThaiChanged = (data) => this.props.retailOfferStore.setDescriptionThai(data);
    descriptionJapaneseChanged = (data) => this.props.retailOfferStore.setDescriptionJapanese(data);
    descriptionVietnameseChanged = (data) => this.props.retailOfferStore.setDescriptionVietnamese(data);

    priceChange = (value) => this.props.retailOfferStore.setPrice(value);
    showBannerOnlyOnChange = (value) => this.props.retailOfferStore.setShowBannerOnly(value);

    handleStartDateChange = (e) => this.props.retailOfferStore.setStartDate(e);
    handleStartTimeChange = (e) => this.props.retailOfferStore.setStartTime(e);
    handleEndDateChange = (e) => this.props.retailOfferStore.setEndDate(e);
    handleEndTimeChange = (e) => this.props.retailOfferStore.setEndTime(e);

    itemSearched = () => {
        this.props.retailOfferStore.setItemSearchValue('');
        this.props.retailOfferStore.searchItem('');
        this.props.retailOfferStore.setShowSearchMenuItemModal(true);
    }

    // UPLOAD Settings

    dummyRequest = ({ file, onSuccess }) => {
        setTimeout(() => {
            onSuccess('ok')
        }, 0);
    }

    beforeUpload = (file, id) => {
        const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/svg+xml';
        if (!isJpgOrPng) {
            notification.warning({
                message: `Failed to upload image`,
                description:
                    'You can only upload JPG/PNG file!',
                placement: 'bottomRight',
            })
        }

        const isLessThan10Mb = file.size / 1024 / 1024 < 2;
        if (!isLessThan10Mb) {
            notification.warning({
                message: `Failed to upload image`,
                description:
                    'Image must smaller than 2MB!',
                placement: 'bottomRight',
            })
        }

        if (isJpgOrPng && isLessThan10Mb) {
            this.props.retailOfferStore.setImageIsLoadingById(id, true);
        }

        return isJpgOrPng && isLessThan10Mb
    }

    uploadChange = (info, id, title) => {
        if (info.file.status) {
            if (info.file.status === 'uploading') {
                this.props.retailOfferStore.setImageUrlById(id, '')
                return
            }
            if (info.file.status === 'done') {
                const category = 'RetailOffer'
                const titleName = Format.RemoveSpecialChars(title) || 'Default'

                ApiCaller.Upload.apiUploadImages(info.file.originFileObj, category, titleName).then(response => {
                    this.props.retailOfferStore.setImageUrlById(id, response.imageUrl)
                    this.props.retailOfferStore.setImageIsLoadingById(id, false);
                })
            }
        }
    }

    isLanguageIdActive = (languageId) => {
        const { activeLanguages } = this.props.CmsLanguageStore;

        if (activeLanguages) {
            const language = activeLanguages.find(fi => fi.id === languageId);
            if (language) {
                return true;
            }
        }

        return false;
    }

    render() {
        const { activeLanguages } = this.props.CmsLanguageStore;

        const { data: webSettting } = this.props.webSettingStore;

        const {
            retailOfferId,
            taskName,
            title,
            titleChinese,
            titleChineseTraditional,
            titleThai,
            titleJapanese,
            titleVietnamese,
            briefDesc,
            briefDescChinese,
            briefDescChineseTraditional,
            briefDescThai,
            briefDescJapanese,
            briefDescVietnamese,
            description,
            descriptionChinese,
            descriptionChineseTraditional,
            descriptionThai,
            descriptionJapanese,
            descriptionVietnamese,
            updateLoading,
            originalPrice,
            price,
            startDate,
            startTime,
            endDate,
            endTime,
            // imageUrl,
            images,
            // originalImageUrl,
            showBannerOnly,
            sort
        } = this.props.retailOfferStore;

        let hasError = true;

        if (showBannerOnly) {
            hasError = images.length > 1 &&
                taskName !== '' &&
                startDate !== null &&
                startTime !== null &&
                endDate !== null &&
                endTime !== null;
        } else {
            hasError = images.length > 1 &&
                taskName !== '' &&
                startDate !== null &&
                startTime !== null &&
                endDate !== null &&
                endTime !== null &&
                title !== '' &&
                briefDesc !== '' &&
                description !== '';
        }

        if (updateLoading) {
            Toast.loading('Saving...', 100, null, true);
        } else {
            Toast.hide();
        }

        return (
            <>
                {
                    activeLanguages
                        ?
                        <>
                            <Form layout='vertical'>

                                <Form.Item label='Item Name'>
                                    <Search
                                        placeholder='search item'
                                        value={taskName}
                                        onSearch={() => this.itemSearched(true)}
                                        enterButton
                                    />
                                </Form.Item>

                                <>
                                    {
                                        images.map(image => {
                                            return (
                                                <Form.Item key={image.id} label={
                                                    image.url === ''
                                                        ?
                                                        'Create Banner (Minimum resolution: 640x480)'
                                                        :
                                                        <>
                                                            <Row className='updateretailoffer-row-label'>
                                                                <Col span={12} className='updateretailoffer-col-label'>Update Banner (Minimum resolution: 640x480)</Col>
                                                                <Col span={12} className='updateretailoffer-col-label-button'>
                                                                    <Button type='danger' onClick={() => this.props.retailOfferStore.removeImageById(image.id)}>Delete</Button>
                                                                </Col>
                                                            </Row>
                                                        </>
                                                }>
                                                    <Upload
                                                        listType='picture-card'
                                                        className='avatar-uploader'
                                                        showUploadList={false}
                                                        customRequest={this.dummyRequest}
                                                        beforeUpload={(info) => this.beforeUpload(info, image.id)}
                                                        onChange={(info) => this.uploadChange(info, image.id, title)}
                                                    >
                                                        {
                                                            image.url !== ''
                                                                ?
                                                                <img src={image.url} alt='avatar' className='updateretailoffer-img' />
                                                                :
                                                                <div>
                                                                    <Icon type={image.isLoading ? 'loading' : 'plus'} />
                                                                    <div className='ant-upload-text'>Upload</div>
                                                                </div>}
                                                    </Upload>
                                                </Form.Item>
                                            )
                                        })
                                    }
                                </>

                                <Form.Item label='Show Banner Only'>
                                    <Switch checkedChildren='Yes' unCheckedChildren='No' checked={showBannerOnly} onChange={this.showBannerOnlyOnChange} />
                                </Form.Item>

                                <Form.Item label='Sort'>
                                    <InputNumber
                                        className='stm-width-100'
                                        value={sort}
                                        onChange={(value) => this.props.retailOfferStore.setsort(value)}
                                        min={0}
                                    />
                                </Form.Item>

                                <React.Fragment>
                                    {
                                        showBannerOnly
                                            ?
                                            null
                                            :
                                            <Tabs defaultActiveKey='1'>
                                                {/* English */}
                                                {
                                                    this.isLanguageIdActive(1)
                                                        ?
                                                        <TabPane tab='English *' key='1'>
                                                            <Form.Item label='Title' className='mg-b-10'>
                                                                <Input placeholder='Insert title' value={title} onChange={this.titleChanged} />
                                                            </Form.Item>
                                                            <Form.Item label='Brief Description (Max. 100 characters)' className='mg-b-10'>
                                                                <TextArea rows={3} maxLength={100} placeholder='Insert brief description' value={briefDesc} onChange={this.briefDescChanged}></TextArea>
                                                            </Form.Item>
                                                            <Form.Item label='Description' className='mg-b-10'>
                                                                <CKEditor
                                                                    editor={ClassicEditor}
                                                                    data={description}
                                                                    onChange={(event, editor) => {
                                                                        const data = editor.getData();
                                                                        this.descriptionChanged(data);
                                                                    }}
                                                                />
                                                            </Form.Item>
                                                        </TabPane>
                                                        :
                                                        null
                                                }

                                                {/* Chinese */}
                                                {
                                                    this.isLanguageIdActive(2)
                                                        ?
                                                        <TabPane tab='简体中文' key='2'>
                                                            <Form.Item label='Title' className='mg-b-10'>
                                                                <Input placeholder='Insert title' value={titleChinese} onChange={this.titleChineseChanged} />
                                                            </Form.Item>
                                                            <Form.Item label='Brief Description (Max. 100 characters)' className='mg-b-10'>
                                                                <TextArea rows={3} maxLength={100} placeholder='Insert brief description' value={briefDescChinese} onChange={this.briefDescChineseChanged}></TextArea>
                                                            </Form.Item>
                                                            <Form.Item label='Description' className='mg-b-10'>
                                                                <CKEditor
                                                                    editor={ClassicEditor}
                                                                    data={descriptionChinese}
                                                                    onChange={(event, editor) => {
                                                                        const data = editor.getData();
                                                                        this.descriptionChineseChanged(data);
                                                                    }}
                                                                />
                                                            </Form.Item>
                                                        </TabPane>
                                                        :
                                                        null
                                                }

                                                {/* Chinese Traditional */}
                                                {
                                                    this.isLanguageIdActive(3)
                                                        ?
                                                        <TabPane tab='繁體中文' key='3'>
                                                            <Form.Item label='Title' className='mg-b-10'>
                                                                <Input placeholder='Insert title' value={titleChineseTraditional} onChange={this.titleChineseTraditionalChanged} />
                                                            </Form.Item>
                                                            <Form.Item label='Brief Description (Max. 100 characters)' className='mg-b-10'>
                                                                <TextArea rows={3} maxLength={100} placeholder='Insert brief description' value={briefDescChineseTraditional} onChange={this.briefDescChineseTraditionalChanged}></TextArea>
                                                            </Form.Item>
                                                            <Form.Item label='Description' className='mg-b-10'>
                                                                <CKEditor
                                                                    editor={ClassicEditor}
                                                                    data={descriptionChineseTraditional}
                                                                    onChange={(event, editor) => {
                                                                        const data = editor.getData();
                                                                        this.descriptionChineseTraditionalChanged(data);
                                                                    }}
                                                                />
                                                            </Form.Item>
                                                        </TabPane>
                                                        :
                                                        null
                                                }

                                                {/* Thai */}
                                                {
                                                    this.isLanguageIdActive(4)
                                                        ?
                                                        <TabPane tab='ไทย' key='4'>
                                                            <Form.Item label='Title' className='mg-b-10'>
                                                                <Input placeholder='Insert title' value={titleThai} onChange={this.titleThaiChanged} />
                                                            </Form.Item>
                                                            <Form.Item label='Brief Description (Max. 100 characters)' className='mg-b-10'>
                                                                <TextArea rows={3} maxLength={100} placeholder='Insert brief description' value={briefDescThai} onChange={this.briefDescThaiChanged}></TextArea>
                                                            </Form.Item>
                                                            <Form.Item label='Description' className='mg-b-10'>
                                                                <CKEditor
                                                                    editor={ClassicEditor}
                                                                    data={descriptionThai}
                                                                    onChange={(event, editor) => {
                                                                        const data = editor.getData();
                                                                        this.descriptionThaiChanged(data);
                                                                    }}
                                                                />
                                                            </Form.Item>
                                                        </TabPane>
                                                        :
                                                        null
                                                }

                                                {/* Japanese */}
                                                {
                                                    this.isLanguageIdActive(5)
                                                        ?
                                                        <TabPane tab='日本' key='5'>
                                                            <Form.Item label='Title' className='mg-b-10'>
                                                                <Input placeholder='Insert title' value={titleJapanese} onChange={this.titleJapaneseChanged} />
                                                            </Form.Item>
                                                            <Form.Item label='Brief Description (Max. 100 characters)' className='mg-b-10'>
                                                                <TextArea rows={3} maxLength={100} placeholder='Insert brief description' value={briefDescJapanese} onChange={this.briefDescJapaneseChanged}></TextArea>
                                                            </Form.Item>
                                                            <Form.Item label='Description' className='mg-b-10'>
                                                                <CKEditor
                                                                    editor={ClassicEditor}
                                                                    data={descriptionJapanese}
                                                                    onChange={(event, editor) => {
                                                                        const data = editor.getData();
                                                                        this.descriptionJapaneseChanged(data);
                                                                    }}
                                                                />
                                                            </Form.Item>
                                                        </TabPane>
                                                        :
                                                        null
                                                }

                                                {/* Vietnamese */}
                                                {
                                                    this.isLanguageIdActive(6)
                                                        ?
                                                        <TabPane tab='Vietnamese' key='6'>
                                                            <Form.Item label='Title' className='mg-b-10'>
                                                                <Input placeholder='Insert title' value={titleVietnamese} onChange={this.titleVietnameseChanged} />
                                                            </Form.Item>
                                                            <Form.Item label='Brief Description (Max. 100 characters)' className='mg-b-10'>
                                                                <TextArea rows={3} maxLength={100} placeholder='Insert brief description' value={briefDescVietnamese} onChange={this.briefDescVietnameseChanged}></TextArea>
                                                            </Form.Item>
                                                            <Form.Item label='Description' className='mg-b-10'>
                                                                <CKEditor
                                                                    editor={ClassicEditor}
                                                                    data={descriptionVietnamese}
                                                                    onChange={(event, editor) => {
                                                                        const data = editor.getData();
                                                                        this.descriptionVietnameseChanged(data);
                                                                    }}
                                                                />
                                                            </Form.Item>
                                                        </TabPane>
                                                        :
                                                        null
                                                }
                                            </Tabs>
                                    }
                                </React.Fragment>

                                <div style={{ borderBottom: '2px solid #1890ff', marginBottom: 20 }} />

                                <Form.Item label='Original Price'>
                                    <Tag color={'blue'} style={{ fontSize: 14, padding: '5px 15px 5px 15px' }}>
                                        {webSettting ? webSettting.currencyCode : ''} {Format.Currency(originalPrice)}
                                    </Tag>
                                </Form.Item>

                                <Form.Item label='Special Price'>
                                    <InputNumber
                                        value={price}
                                        onChange={this.priceChange}
                                        formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                        parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                        style={{ width: '100%' }}
                                    />
                                </Form.Item>

                                <Form.Item label='Start Date Time'>
                                    <DatePicker
                                        size='default'
                                        style={{ width: '65%', marginRight: 12 }}
                                        format='DD MMM YYYY'
                                        value={startDate}
                                        onChange={(e) => this.handleStartDateChange(e)}
                                    />
                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                        <KeyboardTimePicker
                                            margin='dense'
                                            ampm={false}
                                            id='startdatetime-picker'
                                            style={{ width: '30%', marginRight: 5, marginLeft: 5, top: -12 }}
                                            value={startTime}
                                            onChange={(e) => this.handleStartTimeChange(e)}
                                            KeyboardButtonProps={{
                                                'aria-label': 'change time',
                                            }}
                                        />
                                    </MuiPickersUtilsProvider>
                                </Form.Item>

                                <Form.Item label='End Date Time'>
                                    <DatePicker
                                        size='default'
                                        style={{ width: '65%', marginRight: 12 }}
                                        format='DD MMM YYYY'
                                        value={endDate}
                                        onChange={(e) => this.handleEndDateChange(e)}
                                    />
                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                        <KeyboardTimePicker
                                            margin='dense'
                                            ampm={false}
                                            id='enddatetime-picker'
                                            style={{ width: '30%', marginRight: 5, marginLeft: 5, top: -12 }}
                                            value={endTime}
                                            onChange={(e) => this.handleEndTimeChange(e)}
                                            KeyboardButtonProps={{
                                                'aria-label': 'change time',
                                            }}
                                        />
                                    </MuiPickersUtilsProvider>
                                </Form.Item>

                                <Form.Item label='Preview Banner'>
                                    <Row>
                                        <Col span={24} className='updateretailoffer-col-preview-container'>
                                            {
                                                images.length === 1
                                                    ?
                                                    null
                                                    :
                                                    <Row>
                                                        <Col className='updateretailoffer-col-preview-img'>
                                                            <Row>
                                                                <Col
                                                                    span={24}
                                                                    className={images.length === 2 ? 'updateretailoffer-col-carousel-container-single' : 'updateretailoffer-col-carousel-container'}
                                                                >
                                                                    <Carousel>
                                                                        {
                                                                            images.filter(fi => fi.url !== '').map(image => {
                                                                                return (
                                                                                    <div key={image.id} className='updateretailoffer-div-carousel'>
                                                                                        <Row className='updateretailoffer-row-carousel'>
                                                                                            <Col span={24} className='updateretailoffer-col-carousel'>
                                                                                                <img className='updateretailoffer-img-carousel' src={image.url} alt={image.id} />
                                                                                            </Col>
                                                                                        </Row>
                                                                                    </div>
                                                                                )
                                                                            })
                                                                        }
                                                                    </Carousel>
                                                                </Col>
                                                            </Row>
                                                            <React.Fragment>
                                                                {
                                                                    showBannerOnly
                                                                        ?
                                                                        null
                                                                        :
                                                                        <Row className='updateretailoffer-row-detail'>
                                                                            <Col span={24} className='updateretailoffer-col-preview-title'>
                                                                                <Text className='updateretailoffer-text-preview-title'>{title}</Text>
                                                                            </Col>
                                                                            <Col span={24} className='updateretailoffer-col-preview-date'>
                                                                                <Row>
                                                                                    <Col span={11} className='txt-algn-right'>
                                                                                        <Tag color={'blue'} className='fnt-8 mg-0' style={{ padding: '5px 15px 5px 15px' }}>
                                                                                            <Text>{moment(startDate).format("DD MMMM YYYY")}</Text>
                                                                                        </Tag>
                                                                                    </Col>
                                                                                    <Col span={2} className='txt-algn-center'>
                                                                                        <Text>-</Text>
                                                                                    </Col>
                                                                                    <Col span={11}>
                                                                                        <Tag color={'blue'} className='fnt-8' style={{ padding: '5px 15px 5px 15px' }}>
                                                                                            <Text>{moment(endDate).format("DD MMMM YYYY")}</Text>
                                                                                        </Tag>
                                                                                    </Col>
                                                                                </Row>
                                                                            </Col>
                                                                            <Paragraph className='clr-theme-dark-1 fnt-8 txt-algn-center'>
                                                                                <Text delete>
                                                                                    <Tag color={'red'} className='fnt-8' style={{ padding: '5px 15px 5px 15px', borderRadius: 50 }}>
                                                                                        <Text delete>{webSettting ? webSettting.currencyCode : ''} {Format.Currency(originalPrice)}</Text>
                                                                                    </Tag>
                                                                                </Text>
                                                                            </Paragraph>
                                                                            <Paragraph className='clr-theme-dark-1 fnt-10 txt-algn-center'>
                                                                                <Text>
                                                                                    <Tag color={'green'} className='fnt-10' style={{ padding: '5px 15px 5px 15px', borderRadius: 50 }}>
                                                                                        {webSettting ? webSettting.currencyCode : ''} {price ? Format.Currency(price) : ''}
                                                                                    </Tag>
                                                                                </Text>
                                                                            </Paragraph>
                                                                            <Paragraph className='clr-theme-dark-1'>
                                                                                <Markup content={briefDesc} />
                                                                            </Paragraph>
                                                                            <Paragraph className='clr-theme-dark-1'>
                                                                                <Markup content={description} />
                                                                            </Paragraph>
                                                                        </Row>
                                                                }
                                                            </React.Fragment>
                                                        </Col>
                                                    </Row>
                                            }
                                        </Col>
                                    </Row>
                                </Form.Item>

                                <Form.Item>
                                    {
                                        retailOfferId === 0 ? (
                                            <Button onClick={this.createClicked} style={{ marginRight: 10 }} type='primary' disabled={!hasError}>Create</Button>
                                        ) : (
                                            <Button onClick={this.updateClicked} style={{ marginRight: 10 }} type='primary' disabled={!hasError}>Update</Button>
                                        )
                                    }

                                    <Button onClick={this.cancelClicked}>Cancel</Button>
                                </Form.Item>
                            </Form>
                        </>
                        :
                        null
                }
            </>
        )
    }
}

export default UpdateRetailOfferModal